export const glassCard =
  "border border-white/15 dark:border-border/70 bg-white/20 dark:bg-card/75 backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.06)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.35)]";

/** Landing hero search — lighter glass so the background shows through */
export const glassHeroSearch =
  "border border-white/35 dark:border-white/10 bg-white/35 dark:bg-white/[0.05] backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.25)]";

export const glassStat =
  "p-4 rounded-2xl border border-white/20 dark:border-border/60 bg-white/15 dark:bg-card/60 backdrop-blur-xl text-center transition-all hover:bg-white/25 dark:hover:bg-card/80";

export const glassPanel =
  "rounded-2xl border border-white/15 dark:border-border/60 bg-white/15 dark:bg-card/60 backdrop-blur-xl p-6 sm:p-8";

export const glassCardHover =
  `${glassCard} hover:bg-white/30 dark:hover:bg-card/85 hover:border-white/25 dark:hover:border-border/80 transition-all duration-300`;
